export default "__VITE_ASSET__Cc1_nPU$__"